import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import Card from 'react-bootstrap/Card';
import { Profile } from '../../types';
import Avatar, { AvatarSize, AvatarStatus } from '../Avatar';
import Checkbox from '../Checkbox/Checkbox';
import NumberInput from '../NumberInput';
import Button from '../Button';

export type UserCardWithInputProps = {
  item: Profile;
  onClick: React.MouseEventHandler;
  numberInputValue?: number | null | undefined;
  onChange?: (numberInputValue: number | null | undefined) => void;
};

const UserCardWithInput = ({
  item,
  numberInputValue,
  onClick,
  onChange,
}: UserCardWithInputProps) => {
  const { id, value, name, image, relationship } = item;

  return (
    <Card
      bsPrefix={'user-card-with-number-input'}
      className={'d-flex align-items-center position-relative'}
    >
      <Checkbox value={value} className={'position-absolute'} />
      <div className={'d-flex justify-content-center align-items-center'}>
        <Avatar
          id={id}
          size={AvatarSize.LARGE}
          image={image}
          status={AvatarStatus.ENABLED}
          name={name}
        />
      </div>
      <Card.Body className={'d-flex flex-column m-0 ps-3 col-4'}>
        <Card.Title>{relationship === 'self' ? 'You' : name}</Card.Title>
        <Card.Subtitle>
          {relationship === 'self' ? 'Organizer' : relationship}
        </Card.Subtitle>
      </Card.Body>

      <NumberInput
        placeholder={'0'}
        className="mr-2"
        value={numberInputValue || 0}
        onChange={onChange}
        isPercent
        minValue={'0'}
        maxValue={'100'}
      />

      <Button
        onClick={onClick}
        rightIcon={light('close')}
        className={'px-0 close-btn position-absolute'}
      ></Button>
    </Card>
  );
};

export default UserCardWithInput;
